import React, { useState } from 'react';
import Fab from '@mui/material/Fab';
import Chip from '@mui/material/Chip';
import { Carousel, CarouselItem } from 'reactstrap';
import { NavLink, useLocation } from 'react-router-dom';
import { Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import GuestRegisterDialog from 'components/GuestRegisterDialog';
import CartPopOver from 'components/userProfileCard/CartPopOver'
import OfferPanel from 'components/OfferPanel';
import CampaignCorner, { getCampaignTheme, campaignFrameStyle } from 'components/CampaignFrame';
import Tooltip from '@mui/material/Tooltip';
import helpertFn from 'constants/helperFunction';
import './index.css'
import { isMobile } from 'react-device-detect';
import { EllipsisTooltips } from '../TooltipEllipsis/EllipsisTooltips'
import { EllipsedText } from "../TooltipEllipsis/EllipsedText";
import { Tooltip2 } from "../TooltipEllipsis/Tooltip";
const logo = 'https://s3.ap-south-1.amazonaws.com/medideals.assets/PLACEHOLER.JPG';

const SellerProductCard = (props) => {
  const location = useLocation()
  const [tooltipElement, setTooltipElement] = React.useState();
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showRegisterDialog, setShowRegisterDialog] = useState(false);

  const buyerToken = localStorage.getItem('buyer_token');
  const tempToken = localStorage.getItem('temp_token');
  const isBuyerLoggedIn = Boolean(buyerToken);
  const shouldBlur = !buyerToken && !tempToken;

  // Safe toFixed helper — prevents crash when value is undefined/null
  const safeToFixed = (val, digits = 2) => {
    const num = Number(val);
    return isNaN(num) ? '-' : num.toFixed(digits);
  }

  function next(size) {
    if (size === 1) { setActiveIndex(0) }
    else if (activeIndex === 0) { setActiveIndex(activeIndex + 1) }
  }

  function previous(size) {
    if (size === 1) { setActiveIndex(0) }
    else if (activeIndex === 1) { setActiveIndex(activeIndex - 1) }
  }

  function toggle() { setPopoverOpen(!popoverOpen) }

  function addDefaultSrc(ev) {
    ev.target.src = 'https://s3.ap-south-1.amazonaws.com/medideals.assets/PLACEHOLER.JPG'
  }

  const closepop = () => { setPopoverOpen(false) }

  const { value } = props
  const productMRP = props.value && props.value.MRP
  const inventoryID = value && value.inventory_id;
  // The campaign's colour set for the frame and the corner ribbon (see components/CampaignFrame).
  // Null when there is no campaign - and null for a guest, who is shown no campaign layer at all.
  const campaign = getCampaignTheme(value);
  // The footer clips its overflow; let it grow only when the product-tier offer strip shows (see
  // OfferPanel), which is exactly when `campaign` is set. Cards with no product coupon/gift - and
  // every card a guest sees - keep their current height.
  const hasOffers = Boolean(campaign);
  const productName = value && value.Product && value.Product.name && ((value.Product.name).replace(/ /g, '-')).replace(/[\/,  @#%\^;?]/g, ' ').toLowerCase();
  const bgColor = value && (value.medi_type === 'Ethical branded' || value.medi_type === 'Others') ? '#ff7000' :
    value.medi_type === 'Cool chain' ? '#0b68a8' :
      value.medi_type === 'Surgical' || value.medi_type === 'OTC' || value.medi_type === 'Generic' ? '#038d0e' : '#072791'

  const mobileStyles = { BorderBottom: "1px solid red" };

  // Dummy footer shown blurred for non-logged-in users
  const DummyFooter = () => (
    <div>
      <Chip
        className='chipBox'
        style={{ padding: '17px 10px' }}
        label="BUY 10 GET 2 FREE"
        size='small'
      />
      <div className='mt-1'>
        <span className='priceColor price'>₹ 999.99</span>&nbsp;
        <span className='originalPrice font priceFont'>₹ 1299.99</span>
        <br />
        <span className='discountPrice orderQuantity'>Min: 10, Max: 100</span>
      </div>
    </div>
  );

  // Real footer content
  const RealFooter = () => (
    <>
      {value.Discount && value.Discount.discount_type === "Same" ?
        <React.Fragment>
          <EllipsedText>
            <Chip
              className='chipBox'
              style={{ padding: '17px 10px' }}
              label={`Buy ${value.Discount.discount_on_product.purchase} Get ${value.Discount.discount_on_product.bonus} Free`}
              size='small'
            />
          </EllipsedText>
          <span className={'priceColor price'}>&#x20B9;{safeToFixed(value.ePTR)}</span>&nbsp;
          <span className={'originalPrice font priceFont'}>&#x20B9;{safeToFixed(value.PTR)}</span>
          <br />
          <span className='discountPrice orderQuantity'>Min: {value.min_order_quantity}, Max: {value.max_order_quantity}</span>
        </React.Fragment>
        :
        value.Discount && value.Discount.discount_type === "SameAndDiscount" ?
          <React.Fragment>
            <EllipsedText>
              <Chip
                className='chipBox'
                style={{ padding: '17px 10px' }}
                label={`Buy ${value.Discount.discount_on_product.purchase} Get ${value.Discount.discount_on_product.bonus} Free, and ${safeToFixed(value.Discount.discount_per)}% Off`}
                size='small'
              />
            </EllipsedText>
            <span className={'priceColor price'}>&#x20B9;{safeToFixed(value.ePTR)}</span>&nbsp;
            <span className={'originalPrice font priceFont'}>&#x20B9;{safeToFixed(value.PTR)}</span>
            <br />
            <span className='discountPrice orderQuantity'>Min: {value.min_order_quantity}, Max: {value.max_order_quantity}</span>
          </React.Fragment>
          :
          value.Discount && value.Discount.discount_type === "Different" ?
            <React.Fragment>
              <EllipsedText>
                <Chip
                  className='chipBox'
                  style={{ padding: '17px 10px' }}
                  label={`Buy ${value.Discount.discount_on_product.purchase} Get ${value.Discount.discount_on_product.bonus} ${value.OtherProducts?.name} Free`}
                  size='small'
                />
              </EllipsedText>
              <span className={'priceColor price'}>₹{safeToFixed(value.ePTR)}</span>&nbsp;
              <span className={'originalPrice font priceFont'}>&#x20B9;{safeToFixed(value.PTR)}</span>
              <br />
              <span className='discountPrice orderQuantity'>Min: {value.min_order_quantity}, Max: {value.max_order_quantity}</span>
            </React.Fragment>
            :
            value.Discount && value.Discount.discount_type === "DifferentAndDiscount" ?
              <React.Fragment>
                <EllipsedText>
                  <Chip
                    className='chipBox'
                    style={{ padding: '17px 10px' }}
                    label={`Buy ${value.Discount.discount_on_product.purchase} Get ${value.Discount.discount_on_product.bonus} ${value.OtherProducts?.name} Free, and ${safeToFixed(value.Discount.discount_per)}% Off`}
                    size='small'
                  />
                </EllipsedText>
                <span className={'priceColor price'}>₹{safeToFixed(value.ePTR)}</span>&nbsp;
                <span className={'originalPrice font priceFont'}>&#x20B9;{safeToFixed(value.PTR)}</span>
                <br />
                <span className='discountPrice orderQuantity'>Min: {value.min_order_quantity}, Max: {value.max_order_quantity}</span>
              </React.Fragment>
              :
              value.Discount && value.Discount.discount_type === "Discount" ?
                <React.Fragment>
                  <Chip
                    className='chipBox'
                    style={{ padding: '17px 10px' }}
                    label={`${value.Discount.discount_per}% off`}
                    size='small'
                  />
                  <br />
                  <span className={'priceColor price'}>₹{safeToFixed(value.ePTR)}</span>&nbsp;
                  <span className={'originalPrice font priceFont'}>₹{safeToFixed(value.PTR)}</span>
                  <br />
                  <span className='discountPrice orderQuantity'>Min: {value.min_order_quantity}, Max: {value.max_order_quantity}</span>
                </React.Fragment>
                :
                value.Discount === undefined ?
                  <React.Fragment>
                    <span className={'priceColor price'}>&#x20B9;{safeToFixed(value.ePTR)}</span>&nbsp;
                    <span className={'originalPrice font priceFont'}>&#x20B9;{safeToFixed(value.MRP)}</span>
                    <br />
                    <span className='discountPrice orderQuantity'>Min: {value.min_order_quantity}, Max: {value.max_order_quantity}</span>
                  </React.Fragment>
                  :
                  ''
      }
    </>
  );

  return (
    <React.Fragment>
      <EllipsisTooltips onShowTooltip={setTooltipElement} />
      {tooltipElement && <Tooltip2 element={tooltipElement} />}
      <div className="jr-card-buyer text-left pb-2" style={campaignFrameStyle(campaign)}>
        {/* Direct child of the card: `.jr-card-buyer` is the full-width `position: relative` box,
            while the image header below is only as wide as its contents. */}
        <CampaignCorner product={value} blur={shouldBlur} />
        <div className="jr-card-header-color card-header-style seller-card-min-height">
          <Carousel
            autoPlay={false}
            indicators={true}
            activeIndex={activeIndex}
            next={() => next(value && value.Product && value.Product.images ? value.Product.images.length : 1)}
            interval={false}
            previous={() => previous(value && value.Product && value.Product.images ? value.Product.images.length : 1)}
            className='itemImage'>
            {
              value && value.Product && value.Product.images && value.Product.images.length > 0 ?
                value.Product.images.map((image, index) => (
                  <CarouselItem key={index}>
                    <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${inventoryID}`}>
                      <img onError={addDefaultSrc} src={value.Product.images.length === 0 ? logo : `${helpertFn.productImg(image)}`} alt="product" />
                    </NavLink>
                  </CarouselItem>
                ))
                :
                [<CarouselItem key='images'>
                  <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${inventoryID}`}>
                    <img src={logo} onError={addDefaultSrc} alt="product" />
                  </NavLink>
                </CarouselItem>]
            }
          </Carousel>
          <span style={{ padding: '5px 12px', borderRadius: "0 0 10px 0", fontWeight: 'bold', position: 'absolute', zIndex: 1, backgroundColor: `${bgColor}`, color: 'white', width: 'auto' }}>
            {value && value.medi_type === 'Others' ? 'PCD' : value.medi_type}
          </span>
          {
            location.pathname.includes('/view-company') ? null :
              <div>
                {shouldBlur ? (
                  // Show "Show deals" button for non-logged-in users
                  <div className="fab-show-deals">
                    <button
                      style={{
                        fontSize: "14px",
                        padding: '10px',
                        backgroundColor: '#072791',
                        color: 'white',
                        borderRadius: '5px',
                        border: 'none',
                        minWidth: '105px',
                      }}
                      onClick={props.togglePopup}
                    >
                      Show deals
                    </button>
                  </div>
                ) : (
                  <>
                    <Fab className="jr-badge-up" style={{ backgroundColor: `${bgColor}`, color: 'white' }}>
                      <i
                        className="zmdi zmdi-shopping-cart"
                        style={{ float: "left" }}
                        onClick={isBuyerLoggedIn ? toggle : () => setShowRegisterDialog(true)}
                        id={"upc111" + inventoryID}
                      />
                    </Fab>
                    {isBuyerLoggedIn && (
                      <Popover
                        style={{ padding: "5px", paddingBottom: "0px", textAlign: "center", backgroundColor: '#fff' }}
                        trigger="legacy"
                        placement="right"
                        isOpen={popoverOpen}
                        target={"upc111" + inventoryID}
                        toggle={toggle}
                      >
                        <PopoverHeader style={{ padding: "4px 4px", textAlign: "center" }}>Select Quantity</PopoverHeader>
                        <br />
                        <CartPopOver closepop={(e) => closepop(e)} dataFromParent={value} />
                        <PopoverBody style={{ paddingBottom: 0, textAlign: "center" }}></PopoverBody>
                      </Popover>
                    )}
                  </>
                )}
              </div>
          }
        </div>

        {value && value.medi_attribute.includes('Jumbo Deal') ?
          <Chip
            label={'Jumbo Deal'}
            size='small'
            style={{ backgroundColor: `${bgColor}`, padding: '17px 10px', color: 'white', float: 'left', position: 'relative', zIndex: 1, marginTop: '-28px' }}
          />
          : ''
        }

        <div className="jr-card-body pt-2" style={isMobile ? mobileStyles : {}}>
          <div className="product-details cardBodyPadding">
            <EllipsedText>
              <NavLink className="buyerRedirectNavlink" to={`/product-details/${productName}/${inventoryID}`}>
                <h2 className="card-title card-titleIntranet ellipsis w-100" style={{ minHeight: "45px", maxHeight: "45px", marginTop: "2px" }}>
                  {value && value.Product && value.Product.name}
                </h2>
              </NavLink>
            </EllipsedText>
            <EllipsedText>
              <p className="d-flex mb-0 align-items-baseline companyName ellipsis">
                By
                <NavLink className="buyerRedirectNavlink ellipsis" to={`/view-company/${value.Company._id}`}>
                  <h5 className="text-primary ml-1 NameBold ellipsis" style={{ minHeight: "30px", maxHeight: "30px", overflow: "hidden", marginBottom: "2px" }}>
                    {value && value.Company && value.Company.name}
                  </h5>
                </NavLink>
              </p>
            </EllipsedText>
            <div style={{ minHeight: "35px", maxHeight: "35px", marginBottom: "5px", padding: "0px" }}>
              <div className="cardMrp">
                <div>
                  MRP <strong style={{ color: "black" }}>₹ {safeToFixed(value.MRP)}</strong>
                </div>
                {helpertFn.showPrepaid(props.value.medi_type, props.value.Product.isPrepaid && props.value.Product.isPrepaid, props.value.prepaidInven && props.value.prepaidInven) &&
                  <Chip
                    label={'Only Prepaid'}
                    className='text-white bg-danger'
                    size='small'
                    style={{ padding: '17px 10px', float: "right" }}
                  />
                }
              </div>
            </div>
          </div>
        </div>

        {/* Footer Section */}
        <div
          className="jr-card-footer intranetFooterSeller"
          style={{ overflow: hasOffers ? 'visible' : 'hidden', minHeight: '90px', padding: '20px', position: 'relative' }}
        >
          {/* Product-tier coupon/gift only, shown the same way as the main product card (OfferPanel).
              Guests are shown no campaign at all, so the strip drops itself for them. */}
          <OfferPanel product={value} blur={shouldBlur} />
          {shouldBlur ? (
            <>
              {/* Blurred dummy data */}
              <div style={{ filter: 'blur(4px)', userSelect: 'none', pointerEvents: 'none' }}>
                <DummyFooter />
              </div>
              {/* Login overlay on top */}
              <div
                style={{
                  position: 'absolute',
                  top: 0, left: 0, right: 0, bottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer'
                }}
                onClick={props.togglePopup}
              >
              </div>
            </>
          ) : (
            <RealFooter />
          )}
        </div>

      </div>
      <GuestRegisterDialog open={showRegisterDialog} onClose={() => setShowRegisterDialog(false)} />
    </React.Fragment>
  );
}

export default SellerProductCard;